export const HasCompanyCam = (target) =>
  class extends target {
    static get fields() {
      return [
        { name: "hasCompanyCamKey", persist: false, type: "boolean", defaultValue: false },
      ];
    }

    get hasCompanyCamKey() {
      return Boolean(this.companyCamProject)
    }

    set hasCompanyCamKey(value) {
      this.set("hasCompanyCamKey", value);
    }

    get companyCamProject() {
      return this.companyCamIntegrationStore?.find((record) => {
        return record[this.entityType] === this.id && record.key === 'companyCamProject'
      })?.value
    }

    set companyCamProject(value) {
      let record = this.companyCamIntegrationStore?.find((record) => {
        return record[this.entityType] === this.id
      });
      if(!record) {
        // create record
        [record] = this.companyCamIntegrationStore.add({
          [this.entityType]: this.id,
          key: 'companyCamProject',
        });
      }
      record.value = value;
    }

    clearCompanyCamProject() {
      const record = this.companyCamIntegrationStore?.find((record) => {
        return record[this.entityType] === this.id && record.key === 'companyCamProject'
      });
      if (record) {
        this.companyCamIntegrationStore.remove(record);
      }
      this.hasCompanyCamKey = false;
    }
  }

export default HasCompanyCam;
